module.exports = __webpack_public_path__ + "img/exclamation-circle-light.f8fac91.svg";